export const MODAL_FOOTER_PREFIX = "modalFooter";
export const MODAL_MAIN_TEXT_PREFIX = "modalMainText";
export const BUTTON_PREFIX = "button";
export const TOGGLE_INLINE_PREFIX = "toggleInline";
export const DATEPICKER_2 = "datepicker_2";
